import {
  AggregateOnlyInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';
import { InsightCatalogue } from '../InsightCatalogue';

export interface CapacityManagementActualHoursPayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS;
    id: string;
    attributes: {
      aggregate: {
        total_actual_hours: InsightMetric;
      };
    };
  };
}

export const parseCapacityManagementActualHoursPayload = (
  payload: BaseInsightPayload
): CapacityManagementActualHoursPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS,
    data.attributes,
    false,
    true,
    ['total_actual_hours']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { total_actual_hours: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS,
      id: data.id,
      attributes: {
        aggregate: {
          total_actual_hours: typedAttributes.aggregate.total_actual_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
